@let isEditing = enableChanges$|async;
@let machinesValues = machines();
@let metersValues = meters();
@let selectedDevice = selected();
@let titleConnection = connectionOptionsTitle();
@let searchValue = formFilter.get('key')?.value;
@let typesFilter = formFilter.get('types')?.value ?? [];

<div mat-dialog-title class="iot-config-title">
  @if (isNarrowLayout()) {
    <button mat-icon-button type="button" (click)="SIDENAV.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <div class="iot-config-title__text">
    <span class="iot-config-title__heading">{{ 'IotDevices.devicesTitle'|translate }}</span>
    <span class="iot-config-title__subtitle color-secondary-title">
      {{ 'IotDevices.devicesSubtitle'|translate }}
      @if (serialDevice) {
        · {{ serialDevice }}
      }
    </span>
  </div>
  <div class="iot-config-title__actions">
    @if (isEditor) {
      <button mat-flat-button type="button" color="accent" (click)="enableDisableChanges()">
        <mat-icon>{{ isEditing ? 'lock_open' : 'lock' }}</mat-icon>
        {{ (enableChangesTraduction$|async)!|translate }}
      </button>
    }
    <button mat-flat-button color="primary" type="button"
      [disabled]="!isEditing"
      [matMenuTriggerFor]="ADDDEVICEMENU">
      <mat-icon>add</mat-icon>
    </button>
    <mat-menu #ADDDEVICEMENU="matMenu" xPosition="before">
      <button mat-menu-item type="button" (click)="addDevice('machines')">
        <mat-icon [color]="hasErrors('machines') ? 'warn' : undefined">precision_manufacturing</mat-icon>
        <span>{{ 'IotDevices.addMachines'|translate }}</span>
      </button>
      <button mat-menu-item type="button" (click)="addDevice('meters')">
        <mat-icon [color]="hasErrors('meters') ? 'warn' : undefined">electric_meter</mat-icon>
        <span>{{ 'IotDevices.addMeters'|translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>

<mat-dialog-content class="iot-config-content">
  <mat-sidenav-container class="iot-config-container">
    <!-- DEVICES LIST -->
    <mat-sidenav #SIDENAV class="iot-config-sidenav"
      [mode]="isNarrowLayout() ? 'over' : 'side'"
      [opened]="!isNarrowLayout()">
      <div class="iot-config-sidenav__search">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w100">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" autocomplete="off"
            [formControl]="$any(formFilter.get('key'))"
            placeholder="{{'IotDevices.searchDevice'|translate}}">
          @if (searchValue) {
            <button matSuffix mat-icon-button type="button" (click)="formFilter.get('key')?.setValue(undefined)">
              <mat-icon>clear</mat-icon>
            </button>
          }
        </mat-form-field>
        <mat-button-toggle-group class="iot-config-counters w100" multiple
          [formControl]="$any(formFilter.get('types'))"
          (change)="!formFilter.get('types')?.value?.length && formFilter.get('types')?.setValue([$event.source.value])">
          <mat-button-toggle value="machines">
            {{ 'IotDevices.machines'|translate }} ({{ machinesValues.length }})
          </mat-button-toggle>
          <mat-button-toggle value="meters">
            {{ 'IotDevices.meters'|translate }} ({{ metersValues.length }})
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <mat-nav-list class="iot-config-list">
        @if (typesFilter.includes('machines')) {
        @for (machineValue of machinesValues; track machineValue.id; let i = $index) {
          @let rowMachine = machinesValues|transformValueByPredicateFunction:getRowSummaryPredicate:i:data:'machines';
          @if (rowMachine|transformValueByPredicateFunction:rowMatchesSearchPredicate:searchValue:(rowMachine.protocolTraduction|translate)) {
            <a mat-list-item style="height: unset;"
              [activated]="selectedDevice.id == machineValue.id"
              [ngClass]="selectedDevice.id == machineValue.id ? ['background-color-primary-transparent', 'border-color-primary'] : []"
              (click)="requestSelectRow('machines', machineValue.id); isNarrowLayout() && SIDENAV.close()">
              <span matListItemAvatar class="iot-config-list__avatar">
                <mat-icon [svgIcon]="rowMachine.svgIcon"></mat-icon>
              </span>
              <span matListItemTitle class="iot-config-list__title">{{ rowMachine.name ?? (('IotDevices.machine'|translate) + ' ' + (i + 1)) }}</span>
              <span matListItemLine>
                {{ rowMachine.protocolTraduction|translate }}
                @if (rowMachine.model) {
                  · {{ rowMachine.model }}
                }
              </span>
              <span matListItemLine class="iot-config-list__badges">
                <mat-chip-set>
                  <mat-chip class="iot-chip--machine" disableRipple>{{ 'IotDevices.machine'|translate }}</mat-chip>
                </mat-chip-set>
                @if (isRowModified('machines', machineValue.id)) {
                  <span class="iot-modified-badge iot-modified-badge--inline">
                    <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                  </span>
                }
                @if (deviceHasError('machines', machineValue.id)) {
                  <mat-icon color="warn">error</mat-icon>
                }
              </span>
              <span matListItemMeta class="iot-config-list__chevron">
                <mat-icon class="text-color-primary">chevron_right</mat-icon>
              </span>
            </a>
            <mat-divider> </mat-divider>
          }
        }
        }
        @if (typesFilter.includes('meters')) {
        @for (meterValue of metersValues; track meterValue.id; let i = $index) {
          @let rowMeter = metersValues|transformValueByPredicateFunction:getRowSummaryPredicate:i:data:'meters';
          @if (rowMeter|transformValueByPredicateFunction:rowMatchesSearchPredicate:searchValue:(rowMeter.protocolTraduction|translate)) {
            <a mat-list-item style="height: unset;"
              [activated]="selectedDevice.id == meterValue.id"
              [ngClass]="selectedDevice.id == meterValue.id ? ['background-color-primary-transparent', 'border-color-primary'] : []"
              (click)="requestSelectRow('meters', meterValue.id); isNarrowLayout() && SIDENAV.close()">
              <span matListItemAvatar class="iot-config-list__avatar">
                <mat-icon [svgIcon]="rowMeter.svgIcon"></mat-icon>
              </span>
              <span matListItemTitle class="iot-config-list__title">{{ rowMeter.name ?? (('IotDevices.meter'|translate) + ' ' + (i + 1)) }}</span>
              <span matListItemLine>
                {{ rowMeter.protocolTraduction|translate }}
                @if (rowMeter.model) {
                  · {{ rowMeter.model }}
                }
              </span>
              <span matListItemLine class="iot-config-list__badges">
                <mat-chip-set>
                  <mat-chip class="iot-chip--meter" disableRipple>{{ 'IotDevices.meter'|translate }}</mat-chip>
                </mat-chip-set>
                @if (isRowModified('meters', meterValue.id)) {
                  <span class="iot-modified-badge iot-modified-badge--inline">
                    <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                  </span>
                }
                @if (deviceHasError('meters', meterValue.id)) {
                  <mat-icon color="warn">error</mat-icon>
                }
              </span>
              <span matListItemMeta class="iot-config-list__chevron">
                <mat-icon class="text-color-primary">chevron_right</mat-icon>
              </span>
            </a>
            <mat-divider> </mat-divider>
          }
        }
        }
        @if (!machinesValues.length && !metersValues.length) {
          <div class="iot-config-list__empty color-tertiary-title">{{ 'IotDevices.noDevices'|translate }}</div>
        }

        <a mat-list-item [activated]="selectedDevice.kind == 'connectionOptions'"
          (click)="requestSelectRow('connectionOptions'); isNarrowLayout() && SIDENAV.close()">
          <mat-icon matListItemIcon>hub</mat-icon>
          <span matListItemTitle>
            {{ 'IotDevices.modBusOption'|translate }}
            @if (isRowModified('connectionOptions')) {
              <span class="iot-modified-badge iot-modified-badge--inline">
                <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
              </span>
            }
          </span>
          <span matListItemLine>
            @if (titleConnection.title) {
              {{ titleConnection.title }}
            }
            @for (otherValue of titleConnection.otherValues; track getTrackOtherValue($index, otherValue)) {
              @if (otherValue.traduction) {
                {{ otherValue.traduction|translate }}
              }
              @if (otherValue.value) {
                {{ otherValue.value }}
              }
            }
          </span>
          <span matListItemMeta class="iot-config-list__chevron">
            <mat-icon class="text-color-primary">chevron_right</mat-icon>
          </span>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <!-- DETAIL -->
    <mat-sidenav-content class="iot-config-detail">
      <!-- MACHINES -->
      @if (selectedDevice.kind == 'machines' && editForm) {
        @let i = getSelectedIndex();
        @let rowMachine = [editForm.value]|transformValueByPredicateFunction:getRowSummaryPredicate:0:data:'machines';
          <div class="iot-detail" [formGroup]="editForm">
            <div class="iot-detail__header">
              <mat-icon class="iot-detail__icon" [svgIcon]="rowMachine.svgIcon"></mat-icon>
              <div class="iot-detail__heading">
                <div class="iot-detail__title">
                  <span class="truncate">{{ rowMachine.name ?? (('IotDevices.machine'|translate) + ' ' + (i + 1)) }}</span>
                  <mat-chip-set>
                    <mat-chip class="iot-chip--machine" disableRipple>{{ 'IotDevices.machine'|translate }}</mat-chip>
                  </mat-chip-set>
                  @if (deviceHasError('machines', selectedDevice.id)) {
                    <mat-icon color="warn">error</mat-icon>
                  }
                </div>
                <div class="iot-detail__subtitle color-secondary-title">
                  {{ 'IotDevices.protocol'|translate }}: <strong>{{ rowMachine.protocolTraduction|translate }}</strong>
                  @if (rowMachine.model) {
                    <span class="iot-detail__separator">|</span>
                    {{ 'IotDevices.model'|translate }}: <strong>{{ rowMachine.model }}</strong>
                  }
                </div>
              </div>
              @if (isEditing) {
                <button mat-icon-button type="button" [matMenuTriggerFor]="MACHINEMENU">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #MACHINEMENU="matMenu" xPosition="before">
                  <button mat-menu-item type="button" (click)="cloneDevice(selectedDevice.id)">
                    <mat-icon svgIcon="duplicate"></mat-icon>
                    <span>{{ 'IotDevices.duplicate'|translate }}</span>
                  </button>
                </mat-menu>
                <button mat-icon-button color="warn" type="button"
                  matTooltip="{{'delete'|translate}}"
                  (click)="deleteDevice('machines', selectedDevice.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>

            @for (tab of htmlData.machines; track getTrackHtmlTab($index, tab)) {
              @let machineFields = tab.forms|filterByPredicateFunction:filterPredicateFunctionMachines:editForm.value:possiblesCompileMachines;
              @let machineConfigurationGroups = machineFields|transformValueByPredicateFunction:getFormGroupsPredicate:false;
              @let machineParameterGroups = machineFields|transformValueByPredicateFunction:getFormGroupsPredicate:true;
              <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms" class="iot-detail__tabs">
                <mat-tab label="{{'IotDevices.configurationTab'|translate}}">
                  <ng-container *ngTemplateOutlet="MACHINEGROUPS; context: {$implicit: machineConfigurationGroups}"></ng-container>
                </mat-tab>
                @if (machineParameterGroups.length > 0) {
                  <mat-tab label="{{'IotDevices.parametersTab'|translate}}">
                    <ng-container *ngTemplateOutlet="MACHINEGROUPS; context: {$implicit: machineParameterGroups}"></ng-container>
                  </mat-tab>
                }
              </mat-tab-group>
            }

            <ng-template #MACHINEGROUPS let-groups>
              <mat-accordion multi class="iot-groups">
                @for (group of groups; track getTrackFormGroup($index, group)) {
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="iot-groups__title">
                        <mat-icon class="text-color-primary">{{ group.icon }}</mat-icon>
                        {{ group.traduction|translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="huna-field-grid" [attr.inert]="isEditing ? null : ''">
                      @if (group.key == 'general') {
                        <div class="huna-field-grid__full iot-field">
                          <mat-button-toggle-group formControlName="comType">
                            @for (possible of possiblesCompileMachines; track getTrackCompileOption($index, possible)) {
                              <mat-button-toggle [value]="possible.value">
                                {{ possible.traduction|translate }}
                              </mat-button-toggle>
                            }
                          </mat-button-toggle-group>
                          @if (isFieldModified('comType')) {
                            <span class="iot-modified-badge iot-modified-badge--inline">
                              <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                            </span>
                          }
                        </div>
                      }
                      @for (form of group.fields; track getTrackHtmlForm($index, form)) {
                        <div class="iot-field">
                          @if (isFieldModified(form.formControlName)) {
                            <span class="iot-modified-badge">
                              <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                            </span>
                          }
                          <app-get-form-field-from-configuration-file
                            [visualizedClearButton]="false"
                            [ngClass]="form.formControlName"
                            [type]="form|transformValueByPredicateFunction:getTypeFormPredicate:editForm.value"
                            [titleTraduction]="form.traduction"
                            [possibleValues]="form|transformValueByPredicateFunction:getPossiblevaluesPredicate:editForm.value:possibleValuesSpecial?.machines"
                            [elements]="form|transformValueByPredicateFunction:getElementsPredicate:sensorDataType:possibleValuesPointer.element:(currentLang$|async)!"
                            [sensorsData]="form|transformValueByPredicateFunction:getSensorDataPredicate:sensorDataType:possibleValuesPointer.element:(currentLang$|async)!"
                            [min]="form.formOptions?.min"
                            [max]="form.formOptions?.max"
                            [formControlName]="form.formControlName"
                            [idsUsed]="form|transformValueByPredicateFunction:getUsedIdsPredicate:(machinesValues|transformValueByPredicateFunction:getOtherRowsPredicate:selectedDevice.id):editForm.get(form.formControlName)?.value">
                            <div suffix>
                              <button mat-icon-button type="button"
                                (click)="clearOrEnable(editForm,form.formControlName,'machines')">
                                <mat-icon>
                                  @if (editForm.get(form.formControlName)?.disabled) {
                                    edit
                                  } @else {
                                    clear
                                  }
                                </mat-icon>
                              </button>
                            </div>
                          </app-get-form-field-from-configuration-file>
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </ng-template>
          </div>
      }

      <!-- METERS -->
      @if (selectedDevice.kind == 'meters' && editForm) {
        @let i = getSelectedIndex();
        @let rowMeter = [editForm.value]|transformValueByPredicateFunction:getRowSummaryPredicate:0:data:'meters';
          <div class="iot-detail" [formGroup]="editForm">
            <div class="iot-detail__header">
              <mat-icon class="iot-detail__icon" [svgIcon]="rowMeter.svgIcon"></mat-icon>
              <div class="iot-detail__heading">
                <div class="iot-detail__title">
                  <span class="truncate">{{ rowMeter.name ?? (('IotDevices.meter'|translate) + ' ' + (i + 1)) }}</span>
                  <mat-chip-set>
                    <mat-chip class="iot-chip--meter" disableRipple>{{ 'IotDevices.meter'|translate }}</mat-chip>
                  </mat-chip-set>
                  @if (deviceHasError('meters', selectedDevice.id)) {
                    <mat-icon color="warn">error</mat-icon>
                  }
                </div>
                <div class="iot-detail__subtitle color-secondary-title">
                  {{ 'IotDevices.protocol'|translate }}: <strong>{{ rowMeter.protocolTraduction|translate }}</strong>
                  @if (rowMeter.model) {
                    <span class="iot-detail__separator">|</span>
                    {{ 'IotDevices.model'|translate }}: <strong>{{ rowMeter.model }}</strong>
                  }
                </div>
              </div>
              @if (isEditing) {
                <button mat-icon-button color="warn" type="button"
                  matTooltip="{{'delete'|translate}}"
                  (click)="deleteDevice('meters', selectedDevice.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>

            @for (tab of htmlData.meters; track getTrackHtmlTab($index, tab)) {
              @let meterFields = tab.forms|filterByPredicateFunction:filterPredicateFunctionMachines:editForm.value:possiblesCompileMeters;
              @let meterConfigurationGroups = meterFields|transformValueByPredicateFunction:getFormGroupsPredicate:false;
              @let meterParameterGroups = meterFields|transformValueByPredicateFunction:getFormGroupsPredicate:true;
              <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms" class="iot-detail__tabs">
                <mat-tab label="{{'IotDevices.configurationTab'|translate}}">
                  <ng-container *ngTemplateOutlet="METERGROUPS; context: {$implicit: meterConfigurationGroups}"></ng-container>
                </mat-tab>
                @if (meterParameterGroups.length > 0) {
                  <mat-tab label="{{'IotDevices.parametersTab'|translate}}">
                    <ng-container *ngTemplateOutlet="METERGROUPS; context: {$implicit: meterParameterGroups}"></ng-container>
                  </mat-tab>
                }
              </mat-tab-group>
            }

            <ng-template #METERGROUPS let-groups>
              <mat-accordion multi class="iot-groups">
                @for (group of groups; track getTrackFormGroup($index, group)) {
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="iot-groups__title">
                        <mat-icon class="text-color-primary">{{ group.icon }}</mat-icon>
                        {{ group.traduction|translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="huna-field-grid" [attr.inert]="isEditing ? null : ''">
                      @if (group.key == 'general') {
                        <div class="huna-field-grid__full iot-field">
                          <mat-button-toggle-group formControlName="comType">
                            @for (possible of possiblesCompileMeters; track getTrackCompileOption($index, possible)) {
                              <mat-button-toggle [value]="possible.value">
                                {{ possible.traduction|translate }}
                              </mat-button-toggle>
                            }
                          </mat-button-toggle-group>
                          @if (isFieldModified('comType')) {
                            <span class="iot-modified-badge iot-modified-badge--inline">
                              <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                            </span>
                          }
                        </div>
                      }
                      @for (form of group.fields; track getTrackHtmlForm($index, form)) {
                        <div class="iot-field">
                          @if (isFieldModified(form.formControlName)) {
                            <span class="iot-modified-badge">
                              <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                            </span>
                          }
                          <app-get-form-field-from-configuration-file
                            [ngClass]="form.formControlName"
                            [type]="form.type"
                            [titleTraduction]="form.traduction"
                            [possibleValues]="form.possibleValues"
                            [min]="form.formOptions?.min"
                            [max]="form.formOptions?.max"
                            [formControlName]="form.formControlName"
                            [idsUsed]="form|transformValueByPredicateFunction:getUsedIdsPredicate:(metersValues|transformValueByPredicateFunction:getOtherRowsPredicate:selectedDevice.id):editForm.get(form.formControlName)?.value">
                          </app-get-form-field-from-configuration-file>
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </ng-template>
          </div>
      }

      <!-- CONNECTION OPTIONS -->
      @if (selectedDevice.kind == 'connectionOptions' && editForm) {
        <div class="iot-detail" [formGroup]="editForm">
          <div class="iot-detail__header">
            <mat-icon class="iot-detail__icon text-color-primary">hub</mat-icon>
            <div class="iot-detail__heading">
              <div class="iot-detail__title">
                <span class="truncate">{{ 'IotDevices.modBusOption'|translate }}</span>
              </div>
              <div class="iot-detail__subtitle color-secondary-title">
                @if (titleConnection.title) {
                  <strong>{{ titleConnection.title }}</strong>
                }
                @for (otherValue of titleConnection.otherValues; track getTrackOtherValue($index, otherValue)) {
                  @if (otherValue.traduction) {
                    {{ otherValue.traduction|translate }}
                  }
                  @if (otherValue.value) {
                    <strong>{{ otherValue.value }}</strong>
                  }
                }
              </div>
            </div>
          </div>
          @for (tab of htmlData.connectionOptions; track getTrackHtmlTab($index, tab)) {
            <mat-accordion multi class="iot-groups">
              @for (group of tab.forms|transformValueByPredicateFunction:getFormGroupsPredicate:false; track getTrackFormGroup($index, group)) {
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="iot-groups__title">
                      <mat-icon class="text-color-primary">{{ group.icon }}</mat-icon>
                      {{ group.traduction|translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="huna-field-grid" [attr.inert]="isEditing ? null : ''">
                    @for (form of group.fields; track getTrackHtmlForm($index, form)) {
                      <div class="iot-field">
                        @if (isFieldModified(form.formControlName)) {
                          <span class="iot-modified-badge">
                            <mat-icon>edit</mat-icon>{{ 'IotDevices.modified'|translate }}
                          </span>
                        }
                        <app-get-form-field-from-configuration-file
                          [visualizedClearButton]="true"
                          [ngClass]="form.formControlName"
                          [type]="form.type"
                          [titleTraduction]="form.traduction"
                          [possibleValues]="form.possibleValues"
                          [min]="form.formOptions?.min"
                          [max]="form.formOptions?.max"
                          [formControlName]="form.formControlName">
                        </app-get-form-field-from-configuration-file>
                      </div>
                    }
                  </div>
                </mat-expansion-panel>
              }
            </mat-accordion>
          }
        </div>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-flat-button color="accent" [disabled]="saving()" [mat-dialog-close]="undefined">
    <mat-icon>close</mat-icon>
  </button>
  <button mat-flat-button color="primary" type="button"
    [disabled]="!enableChanges || saving()"
    (click)="sendValue()">
    @if (saving()) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      <mat-icon>save</mat-icon>
    }
  </button>
</mat-dialog-actions>

